import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';

function Home(props) {
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div style={{display: "flex", justifyContent: "center", alignItems: "center", boxSizing: "border-box", height: "85vh"}}>
        <img src="/logo.png" alt="Max Control Logo" height="80" />
      </div>
    </Container>
  );

}

export default Home